import styled from 'styled-components';

export const RedListCategoryStatus = styled.div`
  width: 32px;
  height: 24px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  padding: 4px 8px 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: ${(p) => {
    return p.color === '#FFFFFF' ? '1px solid #202020' : p.color === 'rgb(255, 255, 255)' ? '1px solid rgba(32, 32, 32, 0.2)' : 'none'
  }};
  color: ${(p) => {
    return p.color === '#202020' ? '#FFF' : '#202020'
  }};
  background-color: ${(p) => {
    return p.color
  }};
`;

export const StyledCalculationTable = styled.div`
  table {
    td {
      :last-child {
        border-left: 1px solid rgba(32, 32, 32, 0.1);
        text-align: right;       
        padding-right: 16px;
        font-weight: 400;
      }

      :nth-child(2) {
        background: rgba(32, 32, 32, 0.02);
      }
    }
  }
`;

export const StyledCalculationTableEco = styled.div`
  table {
    td {
      :last-child {
        border-left: 1px solid rgba(32, 32, 32, 0.1);
        text-align: right;        
        padding-right: 16px;
        font-weight: 400;
      }
    }
  }
`;

export const SpeciesPaginationWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 32px 0 32px 0;
  border-bottom: 1px solid rgba(32, 32, 32, 0.1);
`;

export const TableNotQualifyIconWrapper = styled.div`  
  height: 24px;
  width: 24px;  
  margin-left: auto;

`;

export const StyledTooltip = styled.div`
  display: inline-block;
`;
